// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarIcon_avatar__His4s","avatarImage":"AvatarIcon_avatarImage__upNDG"};